import React, { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './services/firebase';
import AuthScreen from './components/AuthScreen';
import Dashboard from './components/Dashboard';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import AdminPage from './pages/AdminPage';
import { api } from './lib/api';

function MainRoute() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      if (u) {
        // Sync user to backend to ensure they appear in Admin Dashboard immediately
        api.auth.syncUser(u).catch(err => console.error("Sync user failed", err));
      }
      setUser(u);
      setTimeout(() => setLoading(false), 800);
    });
    return () => unsub();
  }, []);

  if (loading) {
    return (
      <div className="loading-screen" style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh',
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', color: 'white'
      }}>
        <div style={{ fontSize: '4rem', animation: 'spin 2s linear infinite' }}>🌊</div>
        <h2>Cargando Floppy Floods AI...</h2>
      </div>
    );
  }

  return user ? <Dashboard user={user} /> : <AuthScreen />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/" element={<MainRoute />} />
      </Routes>
    </Router>
  );
}

export default App;
